var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnlike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7312 17.6029H41.0725C43.2239 17.6029 44.9842 19.3632 44.9842 21.5146V25.4263C44.9842 25.9348 44.8864 26.4042 44.7104 26.854L38.8037 40.6427C38.217 42.0509 36.8283 43.0288 35.205 43.0288H17.6025C15.4511 43.0288 13.6908 41.2685 13.6908 39.1171V19.5588C13.6908 18.4831 14.1211 17.5052 14.8448 16.8011L27.7142 3.91211L29.7873 5.96573C30.3154 6.49381 30.6479 7.23703 30.6479 8.03892L30.5892 8.66478L28.7312 17.6029ZM9.77917 19.5588H1.95584V43.0288H9.77917V19.5588Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlike);
export default __webpack_public_path__ + "static/media/icon-unlike.f28edb96da1200dccaf02f546a8469c4.svg";
export { ForwardRef as ReactComponent };